export function PageLoading({ label = "正在打开学习室" }: { label?: string }) {
  return (
    <div className="page-loading" role="status">
      <span className="loading-rail">
        <i />
      </span>
      <p>{label}</p>
    </div>
  );
}

